import React from "react"
import types from "prop-types"
import * as API from "services/api"
import { useInterval } from "hooks"
import ActivityIndicator from "components/shared/ActivityIndicator"

const CategoryResetProcessingCheck = ({
  categoryResetId, setCategoryReset, onError, subdomain,
}) => {
  useInterval(async () => {
    const response = await API.getCategoryResetStatus({ subdomain, categoryResetId })
    if (response.ok) {
      setCategoryReset((prev) => ({ ...prev, status: response.data.status }))
    } else {
      onError()
    }
  }, 2000)

  return (
    <div className="flex flex-col items-center">
      <ActivityIndicator className="mb-8" />
    </div>
  )
}

CategoryResetProcessingCheck.propTypes = {
  categoryResetId: types.number.isRequired,
  setCategoryReset: types.func.isRequired,
  onError: types.func.isRequired,
  subdomain: types.string.isRequired,
}

export default CategoryResetProcessingCheck
